// dates
export const LAST_WEEK = 'last_week'
export const YESTERDAY = 'yesterday'
export const TODAY = 'today'
export const TOMORROW = 'tomorrow'
export const NEXT_WEEK = 'next_week'

// recurrence
export const NEVER = 'never'
export const DAILY = 'days'
export const WEEKLY = 'weeks'
export const BIWEEKLY = 'biweekly'
export const MONTHLY = 'months'
export const REGULAR = 'regular'

// statuses
export const NOT_STARTED = 'not_started'
export const IN_PROGRESS = 'in_progress'
export const COMPLETED = 'completed'

// filter types
export const FILTER_TYPE_DATE = 'date'
export const FILTER_TYPE_DATE_RANGE_FROM = 'date_range_from'
export const FILTER_TYPE_DATE_RANGE_TO = 'date_range_to'
export const FILTER_TYPE_OVERDUE = 'overdue'
export const FILTER_TYPE_DELETED = 'deleted'
export const FILTER_TYPE_SITE = 'site'
export const FILTER_TYPE_ASSIGNEE = 'assignee'
export const FILTER_TYPE_ASSIGNED_USER = 'assigned_user'
export const FILTER_TYPE_ASSIGNED_USER_GROUP = 'assigned_user_group'
export const FILTER_TYPE_CREATED_BY = 'created_by'
export const FILTER_TYPE_DUE_DATE = 'end_date'
export const FILTER_TYPE_MEDIA = 'media'
export const FILTER_TYPE_RECURRENCE = 'recurrence'
export const FILTER_TYPE_STATUS = 'state'
export const FILTER_TYPE_JOB_ID = 'id'
export const FILTER_TYPE_MODIFIED_BY = 'modified_by'
export const FILTER_TYPE_TASKS_COMPLETED = 'tasks_completed'
export const FILTER_TYPE_UNITS = 'units'
export const FILTER_TYPE_START_DATE = 'start_date'
export const FILTER_TYPE_CREATED_DATE = 'dateCreated'
export const FILTER_TYPE_COMPLETED_DATE = 'completedDate'
export const FILTER_TYPE_DATE_DELETED = 'dateDeleted'
export const FILTER_TYPE_REASON_FOR_DELETION = 'reasonForDeletion'

// labels
export const LAST_WEEK_LABEL = 'lastWeek'
export const YESTERDAY_LABEL = 'yesterday'
export const TODAY_LABEL = 'today'
export const TOMORROW_LABEL = 'tomorrow'
export const NEXT_WEEK_LABEL = 'nextWeek'
export const ASSIGNEE_LABEL = 'assignee'
export const CREATED_BY_LABEL = 'createdBy'
export const MODIFIED_BY_LABEL = 'modifiedBy'
export const JOB_ID_LABEL = 'jobId'
export const DUE_DATE_LABEL = 'dueDate'
export const MEDIA_LABEL = 'media'
export const RECURRENCE_LABEL = 'recurrence'
export const SITE_NAME_LABEL = 'site'
export const STATUS_LABEL = 'status'
export const NEVER_LABEL = 'never'
export const DAILY_LABEL = 'daily'
export const WEEKLY_LABEL = 'weekly'
export const BIWEEKLY_LABEL = 'biweekly'
export const MONTHLY_LABEL = 'monthly'
export const NOT_STARTED_LABEL = 'notStarted'
export const IN_PROGRESS_LABEL = 'inProgress'
export const COMPLETED_LABEL = 'completed'
export const HAS_MEDIA_LABEL = 'hasMedia'
export const HAS_NO_MEDIA_LABEL = 'hasNoMedia'
export const TASKS_COMPLETED_LABEL = 'tasksCompleted'
export const UNITS_LABEL = 'units'
export const START_DATE_LABEL = 'startDate'
export const END_DATE_LABEL = 'endDate'
export const CREATED_DATE_LABEL = 'created date'
export const COMPLETED_DATE_LABEL = 'completed date'

export const MANAGEMENT_UI_OTHER_FILTERS = [
  {
    label: ASSIGNEE_LABEL,
    value: FILTER_TYPE_ASSIGNEE,
  },
  {
    label: CREATED_BY_LABEL,
    value: FILTER_TYPE_CREATED_BY,
  },
  {
    label: DUE_DATE_LABEL,
    value: FILTER_TYPE_DUE_DATE,
  },
  {
    label: MEDIA_LABEL,
    value: FILTER_TYPE_MEDIA,
  },
  {
    label: RECURRENCE_LABEL,
    value: FILTER_TYPE_RECURRENCE,
  },
  {
    label: STATUS_LABEL,
    value: FILTER_TYPE_STATUS,
  },
]

export const MANAGEMENT_UI_SCHEDULING_FILTERS = [
  FILTER_TYPE_ASSIGNEE,
  FILTER_TYPE_RECURRENCE,
  FILTER_TYPE_CREATED_BY,
]

export const MANAGEMENT_UI_RECURRENCE_FILTER = [
  {
    label: NEVER_LABEL,
    value: NEVER,
  },
  {
    label: DAILY_LABEL,
    value: DAILY,
  },
  {
    label: WEEKLY_LABEL,
    value: WEEKLY,
  },
  {
    label: MONTHLY_LABEL,
    value: MONTHLY,
  },
]

export const MANAGEMENT_UI_STATUS_FILTER = [
  {
    label: NOT_STARTED_LABEL,
    value: NOT_STARTED,
  },
  {
    label: IN_PROGRESS_LABEL,
    value: IN_PROGRESS,
  },
  {
    label: COMPLETED_LABEL,
    value: COMPLETED,
  },
]

export const MANAGEMENT_UI_MEDIA_FILTER = [
  {
    label: HAS_MEDIA_LABEL,
    value: true,
  },
  {
    label: HAS_NO_MEDIA_LABEL,
    value: false,
  },
]

export const DEFAULT_JOB_ASSIGNEES_TMP_DATA = {
  add: {
    users: [],
    user_groups: [],
  },
  remove: {
    users: [],
    user_groups: [],
  },
}

export const MANAGEMENT_UI_DATA_FIELDS = [
  {
    label: ASSIGNEE_LABEL,
    value: FILTER_TYPE_ASSIGNEE,
  },
  {
    label: TASKS_COMPLETED_LABEL,
    value: FILTER_TYPE_TASKS_COMPLETED,
  },
  {
    label: RECURRENCE_LABEL,
    value: FILTER_TYPE_RECURRENCE,
  },
  {
    label: MEDIA_LABEL,
    value: FILTER_TYPE_MEDIA,
  },
  {
    label: JOB_ID_LABEL,
    value: FILTER_TYPE_JOB_ID,
  },
  {
    label: CREATED_DATE_LABEL,
    value: FILTER_TYPE_CREATED_DATE,
  },
  {
    label: CREATED_BY_LABEL,
    value: FILTER_TYPE_CREATED_BY,
  },
  {
    label: MODIFIED_BY_LABEL,
    value: FILTER_TYPE_MODIFIED_BY,
  },
  {
    label: UNITS_LABEL,
    value: FILTER_TYPE_UNITS,
  },
  {
    label: START_DATE_LABEL,
    value: FILTER_TYPE_START_DATE,
  },
  {
    label: DUE_DATE_LABEL,
    value: FILTER_TYPE_DUE_DATE,
  },
  {
    label: SITE_NAME_LABEL,
    value: FILTER_TYPE_SITE,
  },
  {
    label: COMPLETED_DATE_LABEL,
    value: FILTER_TYPE_COMPLETED_DATE,
  },
  {
    label: STATUS_LABEL,
    value: FILTER_TYPE_STATUS,
  },
]

export const SCHEDULING_DATA_FIELDS = [
  {
    label: ASSIGNEE_LABEL,
    value: FILTER_TYPE_ASSIGNEE,
  },
  {
    label: CREATED_BY_LABEL,
    value: FILTER_TYPE_CREATED_BY,
  },
  {
    label: START_DATE_LABEL,
    value: FILTER_TYPE_START_DATE,
  },
  {
    label: END_DATE_LABEL,
    value: FILTER_TYPE_DUE_DATE,
  },
  {
    label: RECURRENCE_LABEL,
    value: FILTER_TYPE_RECURRENCE,
  },
  {
    label: UNITS_LABEL,
    value: FILTER_TYPE_UNITS,
  },
]

// Fields/columns
export const WORKFLOW = 'workflow'
export const FIELD_SITE = 'sitesAndUnits'
export const FIELD_ASSIGNMENT = 'assignment'
export const FIELD_ACTIVE = 'active'
export const FIELD_START_DATE = 'startDate'
export const FIELD_START_DATE_INPUT = 'startDateInput'
export const FIELD_START_DELAY = 'startDelay'
export const FIELD_START_DELAY_DAYS = 'startDelayDays'
export const FIELD_RECURRENCE = 'recurrence'
export const FIELD_DUE_DATE = 'dueDate'
export const FIELD_DUE_DATE_DATE = 'dueDateDate'
export const FIELD_DUE_DATE_TIME = 'dueDateTime'
export const REGULAR_REPEAT_SCHEDULE = 'regularRepeatSchedule'
export const END_DATE = 'endDate'
export const END_DATE_AFTER_NUMBER = 'endDateAfterNumber'
export const END_DATE_AFTER_TERM = 'endDateAfterTerm'
export const REPEAT_BY = 'repeatBy'
export const FREQUENCY = 'frequency'
export const WEEK_ORDINARY_NUMBER = 'weekOrdinalNumber'
export const DAY_OF_WEEK = 'dayOfWeek'
export const DAYS_OF_WEEK = 'daysOfWeek'
export const DAY_OF_MONTH = 'daysOfMonth'
export const REPEAT = 'repeat'
export const START_TIME = 'startTime'
export const ASSIGNMENTS = 'assignments'
export const START_ON = 'startOn'
export const PARAMETER_VALUE = 'value'
export const PARAMETER_LABEL = 'label'
export const PARAMETER_ID = 'id'
export const PARAMETER_TITLE = 'title'
export const FIELD_UNITS = 'units'
export const PARAMETER_NAME = 'name'
export const PARAMETER_CONTAINER_NAME = 'containerName'
export const END_DATE_ON_DATE = 'endDateOnDate'

// values
export const VALUE_IS_COMPLETED = 'completed'
export const VALUE_IS_IN_PROGRESS = 'in_progress'
export const VALUE_START = 'start'
export const VALUE_STOP = 'stop'
export const VALUE_NO_DELAY = 'no_delay'
export const VALUE_NEXT_DAY = 'next_day'
export const VALUE_AFTER_ONE_WEEK = 'after_one_week'
export const VALUE_CUSTOM = 'custom'
export const VALUE_WHEN_PARENT_INPUT = 'parent_input'
export const VALUE_DAYS = 'days'
export const VALUE_WEEKS = 'weeks'
export const VALUE_MONTHS = 'months'
export const VALUE_OCCURRENCES = 'occurrences'
export const VALUE_NEVER = 'never'
export const VALUE_REGULAR = 'regular'
export const VALUE_AFTER = 'after'
export const VALUE_ON = 'on'
export const VALUE_EVERY_DAY = 'every_day'
export const VALUE_ONCE_A_WEEK = 'once_a_week'
export const VALUE_EVERY_WEEKDAY = 'every_weekday'

export const LABEL_IS_COMPLETED = 'isCompleted'
export const LABEL_IS_IN_PROGRESS = 'isInProgress'
export const LABEL_START = 'start'
export const LABEL_STOP = 'stop'
export const LABEL_NO_DELAY = 'noDelay'
export const LABEL_NEXT_DAY = 'nextDay'
export const LABEL_AFTER_ONE_WEEK = 'afterOneWeek'
export const LABEL_CUSTOM = 'custom'
export const LABEL_WHEN_COMPLETED = 'whenCompleted'
export const LABEL_DAYS = 'day_s'
export const LABEL_WEEKS = 'week_s'
export const LABEL_MONTHS = 'month_s'
export const LABEL_OCCURRENCES = 'occurrence_s'
export const LABEL_NEVER = 'never'
export const LABEL_EVERY_DAY = 'everyDay'
export const LABEL_ONCE_A_WEEK = 'onceAWeek'
export const LABEL_EVERY_WEEEKDAY = 'everyWeekday'

export const ADDITIONAL_DELAY_ACTIONS = [
  {
    label: LABEL_NO_DELAY,
    value: VALUE_NO_DELAY,
  },
  {
    label: LABEL_NEXT_DAY,
    value: VALUE_NEXT_DAY,
  },
  {
    label: LABEL_AFTER_ONE_WEEK,
    value: VALUE_AFTER_ONE_WEEK,
  },
  {
    label: LABEL_CUSTOM,
    value: VALUE_CUSTOM,
  },
]

export const DAYS_OF_MONTH = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10', value: 10 },
  { label: '11', value: 11 },
  { label: '12', value: 12 },
  { label: '13', value: 13 },
  { label: '14', value: 14 },
  { label: '15', value: 15 },
  { label: '16', value: 16 },
  { label: '17', value: 17 },
  { label: '18', value: 18 },
  { label: '19', value: 19 },
  { label: '20', value: 20 },
  { label: '21', value: 21 },
  { label: '22', value: 22 },
  { label: '23', value: 23 },
  { label: '24', value: 24 },
  { label: '25', value: 25 },
  { label: '26', value: 26 },
  { label: '27', value: 27 },
  { label: '28', value: 28 },
  { label: '29', value: 29 },
  { label: '30', value: 30 },
  { label: '31', value: 31 },
]

export const WEEK_NUMBERS = [
  { label: 'first', value: 'first' },
  { label: 'second', value: 'second' },
  { label: 'third', value: 'third' },
  { label: 'fourth', value: 'fourth' },
  { label: 'fifth', value: 'fifth' },
  { label: 'last', value: 'last' },
]

export const DAYS_OF_WEEK_OPTIONS = [
  { label: 'monday', value: 'Mon' },
  { label: 'tuesday', value: 'Tue' },
  { label: 'wednesday', value: 'Wed' },
  { label: 'thursday', value: 'Thu' },
  { label: 'friday', value: 'Fri' },
  { label: 'saturday', value: 'Sat' },
  { label: 'sunday', value: 'Sun' },
]

export const DAYS_OF_WEEK_SHORTENED_OPTIONS = [
  { label: 'mon', value: 'Mon' },
  { label: 'tue', value: 'Tue' },
  { label: 'wed', value: 'Wed' },
  { label: 'thu', value: 'Thu' },
  { label: 'fri', value: 'Fri' },
  { label: 'sat', value: 'Sat' },
  { label: 'sun', value: 'Sun' },
]

export const END_DATE_TERMS = [
  { label: 'days', value: 'days' },
  { label: 'months', value: 'months' },
  { label: 'weeks', value: 'weeks' },
  { label: 'occurrences', value: 'occurrences' },
]

export const FORMATTED_REPEAT_ACTIONS = [
  {
    label: 'never',
    value: NEVER,
  },
  {
    label: 'regular',
    value: REGULAR,
  },
]

export const FORMATTED_STOP_RECURRENCE_ACTIONS = [
  {
    label: 'days',
    value: VALUE_DAYS,
  },
  {
    label: 'weeks',
    value: VALUE_WEEKS,
  },
  {
    label: 'months',
    value: VALUE_MONTHS,
  },
]

export const ADDITIONAL_REPEAT_ACTIONS = [
  {
    label: LABEL_NEVER,
    value: VALUE_NEVER,
  },
  {
    label: LABEL_EVERY_DAY,
    value: VALUE_EVERY_DAY,
  },
  {
    label: LABEL_ONCE_A_WEEK,
    value: VALUE_ONCE_A_WEEK,
  },
  {
    label: LABEL_EVERY_WEEEKDAY,
    value: VALUE_EVERY_WEEKDAY,
  },
  {
    label: LABEL_CUSTOM,
    value: VALUE_CUSTOM,
  },
]

export const ADDITIONAL_END_DELAY_ACTIONS = [
  {
    label: LABEL_NEVER,
    value: VALUE_NEVER,
  },
  {
    label: LABEL_CUSTOM,
    value: VALUE_CUSTOM,
  },
]

export const LOCUS = 'locus'
export const LOCUS_GROUP = 'locus_group'
export const MAX_STOP_AFTER_TERM_VALUES = {
  MONTHS: 6,
  WEEKS: 24,
  DAYS: 180,
  OCCURRENCES: 180,
}
export const PAGINATION_PAGE = 'page'
